export default {
  header: {
    title: 'Super ! Vous obtenez gratuitement avec votre commande :',
    subtitle: 'Nous appliquerons la remise lors du paiement.',
  },
  footer: {
    buttons: {
      no_thanks: 'Non, merci',
      add_to_basket: 'Ajouter au panier',
    },
  },
};
